import React, {
  ReactElement,
  useContext,
  useEffect,
  useMemo,
  useRef,
} from 'react';
import { makeConfig } from '../helpers/Helper';
import SocketContext from './SocketContext';
import AccountContext from './AccountContext';

function sendAuthMessage(ws: WebSocket, accessToken: string) {
  ws.send(
    JSON.stringify({
      action: 'auth',
      data: accessToken,
    })
  );
}

const SocketProvider = ({ children }: { children: ReactElement }) => {
  const socketRef = useRef<WebSocket | null>(null);
  const socket = socketRef.current;
  const { accountResponse } = useContext(AccountContext);

  useEffect(() => {
    if (socket?.readyState !== 1 && accountResponse?.accessToken) {
      const apiUrlConfig = makeConfig();
      const newSocket = new WebSocket(apiUrlConfig.socketUrl);
      socketRef.current = newSocket;

      newSocket.onopen = () => {
        sendAuthMessage(newSocket, accountResponse.accessToken);
      };

      newSocket.addEventListener('message', (e) => {
        const msg = JSON.parse(e.data);
        const isFrontendMessage =
          (msg.channel === 'frontend' || msg.data?.channel === 'frontend') &&
          (msg.type === 'notify' || msg.type === 'dialog');
        if (isFrontendMessage) {
          newSocket.dispatchEvent(
            new CustomEvent('frontendMessage', { detail: msg })
          );
        }
      });
    }

    return () => {
      socket?.close();
    };
  }, [accountResponse?.accessToken, socket]);

  const value = useMemo(() => ({ socket }), [socket]);

  return (
    <SocketContext.Provider value={value}>{children}</SocketContext.Provider>
  );
};

export default SocketProvider;
